import ItemNumber from './ItemsNumber.component';

export default ItemNumber;
